import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-time-up-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  templateUrl: './time-up-dialog.component.html',
  styleUrls: ['./time-up-dialog.component.scss']
})
export class TimeUpDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<TimeUpDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) { }

  viewResult() {
    this.dialogRef.close({ action: 'viewResult', result: this.data.result });
  }
}